(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const BEDKASTEN_URL = '/collections/opklapbedden';

  const label = (el) => String(el?.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
  const isBedkasten = (el) => label(el) === 'BEDKASTEN';

  const convertBedkastenDesktop = () => {
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary || !isBedkasten(summary)) return;

      const wrapper = details.closest('header-menu') || details;
      const link = document.createElement('a');
      link.id = summary.id || 'HeaderMenu-bedkasten';
      link.href = BEDKASTEN_URL;
      link.className = 'header__menu-item list-menu__item link link--text focus-inset';
      link.innerHTML = '<span>BEDKASTEN</span>';
      wrapper.replaceWith(link);
    });
  };

  const setOpen = (details, open) => {
    details.toggleAttribute('open', open);
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(open));
  };

  const closeOthers = (current) => {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((details) => {
      if (details !== current) setOpen(details, false);
    });
  };

  const bind = (details) => {
    if (details.dataset.ncHoverBound === 'true') return;
    details.dataset.ncHoverBound = 'true';

    const summary = details.querySelector(':scope > summary');
    if (isBedkasten(summary)) return;
    let closeTimer;

    const open = () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(closeTimer);
      closeOthers(details);
      setOpen(details, true);
    };

    const close = () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!details.matches(':hover') && !details.contains(document.activeElement)) {
          setOpen(details, false);
        }
      }, 120);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', close);

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!desktopHover.matches) return;
        event.preventDefault();
        open();
      });
    }
  };

  const init = () => {
    convertBedkastenDesktop();
    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(bind);
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    if (!summary || !isBedkasten(summary)) return;
    if (!summary.closest('.section-header, .header-wrapper, #shopify-section-header')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(BEDKASTEN_URL);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
